(function () {
  var popup = document.querySelector('[data-tdp-newsletter-popup]');
  if (!popup) return;

  var STORAGE_SUBSCRIBED = 'tdp_newsletter_subscribed';
  var STORAGE_DISMISSED = 'tdp_newsletter_dismissed_at';
  var DISMISS_DAYS = 30;

  function show() {
    popup.hidden = false;
    requestAnimationFrame(function () {
      popup.classList.add('tdp-newsletter-popup--visible');
    });
  }

  function hide() {
    popup.classList.remove('tdp-newsletter-popup--visible');
    window.setTimeout(function () {
      popup.hidden = true;
    }, 300);
  }

  var isSubscribed = popup.hasAttribute('data-tdp-newsletter-subscribed');
  var justSubscribed = !!popup.querySelector('[data-tdp-newsletter-success]');
  var hasError = !!popup.querySelector('.tdp-newsletter-popup__error');

  try {
    if (isSubscribed || justSubscribed) {
      localStorage.setItem(STORAGE_SUBSCRIBED, '1');
    }
  } catch (e) {}

  var alreadySubscribed = false;
  var recentlyDismissed = false;
  try {
    alreadySubscribed = localStorage.getItem(STORAGE_SUBSCRIBED) === '1';
    var dismissedAt = parseInt(localStorage.getItem(STORAGE_DISMISSED), 10);
    if (dismissedAt) {
      var daysSince = (Date.now() - dismissedAt) / (1000 * 60 * 60 * 24);
      recentlyDismissed = daysSince < DISMISS_DAYS;
    }
  } catch (e) {}

  if (hasError || justSubscribed) {
    show();
    if (justSubscribed) {
      window.setTimeout(hide, 10000);
    }
  } else if (!alreadySubscribed && !recentlyDismissed) {
    window.setTimeout(showAfterCookieBanner, 2000);
  }

  // Une seule fenetre a la fois : tant que le bandeau ou la fenetre des
  // preferences cookies de Shopify est ouvert, la newsletter attend ; elle
  // s'ouvre 2 secondes apres leur fermeture.
  function cookieBannerOpen() {
    var els = [document.getElementById('shopify-pc__banner'), document.getElementById('shopify-pc__prefs__dialog')];
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (!el) continue;
      var r = el.getBoundingClientRect();
      var cs = window.getComputedStyle(el);
      if (r.width > 0 && r.height > 0 && cs.display !== 'none' && cs.visibility !== 'hidden') return true;
    }
    return false;
  }

  function showAfterCookieBanner() {
    if (!cookieBannerOpen()) { show(); return; }
    var timer = window.setInterval(function () {
      if (cookieBannerOpen()) return;
      window.clearInterval(timer);
      window.setTimeout(show, 2000);
    }, 500);
  }

  var closeButton = popup.querySelector('[data-tdp-newsletter-close]');
  if (closeButton) {
    closeButton.addEventListener('click', function () {
      try {
        localStorage.setItem(STORAGE_DISMISSED, String(Date.now()));
      } catch (e) {}
      hide();
    });
  }
})();
